import styled from 'styled-components'

export const Layout = styled.div`
  position: relative;
  padding: 16px 12px;
  width: 100%;

  flex: 1 1 auto;
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  flex-direction: column;

  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: ${({ theme }) => theme.zds.border.radius100};
  overflow: hidden;
`
